import { render, staticRenderFns } from "./ListaUnimed.vue?vue&type=template&id=39e2060c&scoped=true&"
import script from "./ListaUnimed.vue?vue&type=script&lang=js&"
export * from "./ListaUnimed.vue?vue&type=script&lang=js&"
import style0 from "./ListaUnimed.vue?vue&type=style&index=0&id=39e2060c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2060c",
  null
  
)

export default component.exports